import React from 'react';
import { translate } from 'react-i18next';
import { Text, TextButton } from 'wix-style-react';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';

const PriceCta = ({ t, expert, onClick }) => {
  return (
    <>
      <Text
        weight="normal"
        size="medium"
        secondary={false}
        light={false}
        dataHook="expert-card-lowest-service"
      >
        {t(`client-exploreexperts-${expert.minimalPricing.serviceId}-cta`)}
      </Text>
      <TextButton
        as="button"
        onClick={onClick}
        suffixIcon={<ChevronRight />}
        weight="normal"
        dataHook="expert-card-lowest-service-price"
      >
        {t('client-exploreexperts-static-cta', {
          price: expert.minimalPricing.price.toLocaleString(),
        })}
      </TextButton>
    </>
  );
};

export default translate()(PriceCta);
